import { render, staticRenderFns } from "./MASnippet.vue?vue&type=template&id=8e5c8a08&scoped=true"
import script from "./MASnippet.vue?vue&type=script&lang=js"
export * from "./MASnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5c8a08",
  null
  
)

export default component.exports